import { notificationDateTime } from '@/utils/date'
import Vue, { PropType, VNode } from 'vue'
import { VAvatar, VBtn, VImg, VLayout, VRow, VSpacer } from 'vuetify/lib'
import { INotificationBaseProps, INotificationItem } from './NotificationItemBase'
import { FORNECEDORES } from '@/constants'
import { FornecedorHelper, PropostaHelper } from '@/utils'
import { formatCPFFilter } from '@/filters'
import { ROUTERS } from '@/router/ROUTERS'

interface computedProps {
	topicText: string
	isUnread: boolean
}

interface INotificationBaseComponentProps extends INotificationBaseProps {
	bankId: FORNECEDORES
	createdAt: string
	readAt: string | null
}

export const NotificationTopic = Vue.component('NotificationTopic', {
	name: 'NotificationTopic',

	props: {
		notification: { type: Object as PropType<INotificationItem>, required: true }
	},

	computed: {
		clientName(): string {
			const nameSplit = this.notification.clientName.split(' ')
			const firstName = nameSplit[0]
			const lastName = nameSplit[nameSplit.length - 1]

			return `${firstName} ${lastName}`
		},

		topicText(): VNode {
			if (this.notification.category === 'PreAnalise') {
				return (
					<div>
						<VBtn
							active-class="no-active"
							exact-active-class="no-active"
							exact-path=""
							text
							to={{
								name: ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.DETALHES,
								params: { preanaliseId: this.notification.proposalId.toString() }
							}}
						>
							#{this.notification.proposalId} - {this.clientName} - Pré Análise
						</VBtn>
					</div>
				)
			}

			return (
				<div>
					<VBtn
						active-class="no-active"
						exact-active-class="no-active"
						exact-path=""
						text
						to={{
							name: ROUTERS.PROPOSTAS.PROPOSTA,
							params: { propostaId: this.notification.proposalId.toString(), tab: this.proposalTab }
						}}
					>
						#{this.notification.proposalId} - {this.clientName} - {PropostaHelper.getStatusDescricao(this.notification.proposalStatus)}
					</VBtn>
				</div>
			)
		},

		isUnread(): boolean {
			return this.notification.readAt === null
		},

		proposalTab(): string {
			switch (this.notification.topic) {
				case 'Status':
					return '1'
				case 'Observacao':
					return '3'
			}
		}
	},

	render() {
		return (
			<VRow no-gutters align="center" class="my-1">
				<span class={['text-subtitle-1', !this.isUnread ? 'ml-1' : '']}>{this.topicText}</span>

				{/* //@ts-ignore */}
				{this.notification.bankId != FORNECEDORES.UNKNOW && (
					<div class="notification-bank-logo ml-2">
						<VImg src={FornecedorHelper.getImagePathById(this.notification.bankId)} />
					</div>
				)}
			</VRow>
		)
	}
})

export default NotificationTopic
